import sms from "assets/images/email.svg";
import message from "assets/images/message.svg";
import expire from "assets/images/expire.svg";
import group from "assets/images/user-group.svg";
import branch from "assets/images/branch.svg";

export default function SubscriptionDesktop() {
  return (
    <div className="w-full h-[60%] bg-[#EEEEEE] rounded-xl flex items-center justify-center flex-col gap-[10px]">
      <div className="w-full h-[10%] flex items-center justify-center">
        <button className="w-[180px] h-[30px] rounded-2xl bg-[#2C9BD7] font-medium text-[14px] text-[#FFFFFF]">
          Subscription Details
        </button>
      </div>
      <div className="w-[90%] h-[14%] bg-white rounded flex items-center justify-center gap-[15px] ">
        <div className="w-[40px] h-[40px] rounded-3xl border-[#FFFFFF] bg-red-500 flex items-center justify-center">
          <img src={expire} alt="" />
        </div>
        <div className="w-[40%] h-[100%]">
          <p>Expires on</p>
          <h1>08-08-2026</h1>
        </div>
      </div>
      <div className="w-[90%] h-[14%] bg-white rounded flex items-center justify-between ps-[10px] pe-[10px] ">
        <div className="w-[30%] h-[100%]">
          <p>sms</p>
          <h1>1257/2954</h1>
        </div>
        <div className="w-[40px] h-[40px] rounded-3xl border-[#FFFFFF] bg-black flex items-center justify-center">
          <img src={message} alt="" />
        </div>
      </div>
      <div className="w-[90%] h-[14%] bg-white rounded flex items-center justify-between ps-[10px] pe-[10px] ">
        <div className="w-[40px] h-[40px] rounded-3xl border-[#FFFFFF] bg-black flex items-center justify-center">
          <img src={sms} alt="" />
        </div>
        <div className="w-[30%] h-[100%]">
          <p>Email</p>
          <h1>1257/2954</h1>
        </div>
      </div>
      <div className="w-[90%] h-[14%] bg-white rounded flex items-center justify-between ps-[10px] pe-[10px] ">
        <div className="w-[30%] h-[100%]">
          <p>Branch</p>
          <h1>1257/2954</h1>
        </div>
        <div className="w-[40px] h-[40px] rounded-3xl border-[#FFFFFF] bg-black flex items-center justify-center">
          <img src={branch} alt="" />
        </div>
      </div>
      <div className="w-[90%] h-[14%] bg-white rounded flex items-center justify-between ps-[10px] pe-[10px] ">
        <div className="w-[40px] h-[40px] rounded-3xl border-[#FFFFFF] bg-black flex items-center justify-center">
          <img src={group} alt="" />
        </div>
        <div className="w-[30%] h-[100%]">
          <p>staff</p>
          <h1>1257/2954</h1>
        </div>
      </div>
    </div>
  );
}
